import ApiClient from './ApiClient'

export default class DbsService {

  constructor() {
    this.apiClient = new ApiClient()
  }

  uploadDocument(documentType, file) {
    const formData = new FormData()
    formData.append('docType', documentType)
    formData.append('file', file)

    return this.apiClient.createAuthed().post(
      'dbscheck/uploaddocument',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }

  submit(fileNames) {
    return this.apiClient.createAuthed().post(
      'dbscheck/submitforreview',
      fileNames
    )
  }

}